var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3Pfeilrechts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.2217,
    cy: 22.5459,
    r: 21.8525,
    fill: "#1F1F1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4555 15.7979L29.5293 21.8717C29.7162 22.0585 29.9256 22.2881 30.1649 22.5483C29.8839 22.8293 29.7152 23.0355 29.5293 23.2214L23.4555 29.2952C23.065 28.9046 23.1431 29.0033 22.7704 28.6306C22.3977 28.2579 22.5114 28.351 22.1058 27.9455L26.5503 23.5009H14.2793V21.5921H26.5503L22.1058 17.1476L22.7769 16.4689L23.4555 15.7979Z",
    fill: "#F0F1F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Pfeilrechts);
export default __webpack_public_path__ + "static/media/3 Pfeil rechts.b588b10d22483fb6c58a5fff59054254.svg";
export { ForwardRef as ReactComponent };